import { render } from "./CuentaForm.vue?vue&type=template&id=6230dc40&scoped=true"
import script from "./CuentaForm.vue?vue&type=script&lang=js"
export * from "./CuentaForm.vue?vue&type=script&lang=js"

import "./CuentaForm.vue?vue&type=style&index=0&id=6230dc40&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6230dc40"]])

export default __exports__